import { addDays } from './add-days';
import { createDate } from './create-date';
/**
 * A function returning the last date of the month.
 *
 * @param date - The initial date.
 * @returns - The last date of the initial date month.
 *
 * @example
 * ```ts-no-run
 * lastDayOfMonth(new Date(2016, 0, 15)); // 2016-01-31
 * ```
 */
export var lastDayOfMonth = function (date) {
    var newDate = createDate(date.getFullYear(), date.getMonth() + 1, 1);
    return addDays(newDate, -1);
};



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-date-math/dist/es/last-day-of-month.js
// module id = ../../../../@progress/kendo-date-math/dist/es/last-day-of-month.js
// module chunks = 3